import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          label: {
            email: 'Email',
            password: 'Password',
            chitName: 'Chit Name',
            totalMembers: 'Total Members',
            perPersonAmount: 'Per Person Amount',
            auctionInterval: 'Auction Interval (months)',
            firstAuctionDate: 'First Auction Date',
            auctionAmount: 'Auction Amount',
            auctionNumber: 'Auction Number',
            auctionDate: 'Auction Date',
            membersPay: 'Members Pay',
            winnerName: 'Winner Name',
            continueWith: 'or continue with',
            login: 'Login with',
            signup: 'Sign up with',
            amountChoiceSelection: 'Enter Auction Amount?',
            hasWonSelection: 'I won this auction'
          },
          button: {
            login: 'Login',
            signup: 'Sign Up',
            signout: 'Sign Out',
            about: 'About',
            completedChits: 'Completed Chits',
            addChit: 'Add Chit',
            editChit: 'Edit Chit',
            editAuction: 'Edit Auction',
            saveChit: 'Save Chit',
            calculatePayable: 'Calculate Payable',
            saveAuction: 'Save Auction',
            profile: 'Profile',
            googleSignUp: 'Sign up with google'
          },
          text: {
            accountClarification1: 'Don\'t have an account?',
            accountClarification2: 'Already have an account?',
            about: 'Chit Tracker helps you track all your Chits easily.',
            upcomingInstallments: 'Upcoming Installments',
            incomplete: 'Incomplete',
            completed: 'Completed',
            auctionAmount: 'Auction amount',
            winnerTook: 'Winner took',
            winner: 'Winner',
            remMembersPaid: 'Rem. members paid',
            prevWinnersPaid: 'Previous winners paid',
            fee: 'Fee',
            expense: 'Expense',
            totalExpenses: 'Total expenses',
            commission: 'Commission',
            nextAuction: 'Next Auction',
            completedAuctions: 'Completed Auctions',
            addChitDetailsMessage: 'Please add chit details.',
            chitDetailMembers: 'members',
            installmentsRemaining_one: 'installment remaining',
            installmentsRemaining_other: 'installments remaining',
            intervalMonth_one: '{{count}} month',
            intervalMonth_other: '{{count}} months',
            interval: 'Once in {{frequency}}',
            addAuctionTitle: 'Add auction for \'{{chitName}}\' chit',
            editAuctionTitle: 'Edit auction for \'{{chitName}}\' chit',
            prevAuctionAmount: 'Previous auction amount',
            prevWinnerTook: 'Previous winner took',
            calculatePayableMessage: 'Enter above details to calculate payments.',
            calculatePayableErrMsg: 'Please calculate payable amount',
            winnerTakes: 'Winner takes \'{{amount}}\'',
            previousWinnersPay_one: 'Previous winner need to pay \'{{amount}}\'.',
            previousWinnersPay_other: 'Previous {{count}} winners need to pay \'{{amount}}\' each.',
            remMembersPay_one: 'Remaining member need to pay \'{{amount}}\'.',
            remMembersPay_other: 'Remaining {{count}} members need to pay \'{{amount}}\' each.',
            chitsIncompleteMessage: 'No chits were completed yet.',
            loginErrorInvalidCredentials: 'Invalid email and password.',
            loginErrorEmailNotConfirmed: 'Please click "Confirm your mail" in the email that we sent you.',
            loginErrorGeneric: 'Something went wrong during Login.',
            signupErrorPassword: 'Password should be at least 6 characters.',
            signupErrorGeneric: 'Something went wrong during Signup.',
            signupSuccess: 'Signup succeeded! Please click "Confirm your mail" in the email that we sent you.',
            dataUpdateErrorGeneric: "Something went wrong! Please try again.",
            dataUpdateErrorAuctionForm: "Something went wrong! New auction was added but Chit wasn't updated.",
            pastAuctionsFetchError: "Something went wrong while finding past auctions! Please refresh the page.",
            summary: "Summary",
            totalAmountPaid: "Total amount paid",
            wonAuctionBadgeMessage: "I won this auction",
            wonAmount: "Won amount"
          }
        }
      },
      tn: {
        translation: {
          label: {
            email: 'மின்னஞ்சல் முகவரி',
            password: 'கடவுச்சொல்',
            chitName: 'சீட்டின் பெயர்',
            totalMembers: 'மொத்த உறுப்பினர்கள்',
            perPersonAmount: 'ஒவ்வொரு நபரும் செலுத்த வேண்டியது',
            auctionInterval: 'ஏல இடைவெளி (மாதங்கள்)',
            firstAuctionDate: 'முதல் ஏல தேதி',
            auctionAmount: 'ஏல தொகை',
            auctionNumber: 'ஏல எண்',
            auctionDate: 'ஏல தேதி',
            membersPay: 'உறுப்பினர்கள் செலுத்துவது',
            winnerName: 'வெற்றியாளர் பெயர்',
            continueWith: 'அல்லது',
            login: 'உள்நுழைய',
            signup: 'பதிவு செய்ய',
            amountChoiceSelection: 'ஏலத் தொகையை உள்ளிட',
            hasWonSelection: 'நான் வெற்றி பெற்றேன்'
          },
          button: {
            login: 'உள்நுழை',
            signup: 'பதிவு செய்யவும்',
            signout: 'வெளியேறு',
            about: 'பற்றி',
            completedChits: 'முடிவடைந்த சீட்டுகள்',
            addChit: 'சீட்டை சேர்க்கவும்',
            editChit: 'சீட்டை திருத்து',
            editAuction: 'ஏலத்தை திருத்து',
            saveChit: 'சீட்டை சேமிக்கவும்',
            calculatePayable: 'செலுத்த வேண்டியதை கணக்கிடு',
            saveAuction: 'ஏலத்தை சேமிக்கவும்',
            profile: 'சுயவிவரம்',
            googleSignUp: 'Google உடன் பதிவு செய்யவும்'
          },
          text: {
            accountClarification1: 'கணக்கு இல்லையா?',
            accountClarification2: 'ஏற்கனவே கணக்கு உள்ளதா?',
            about: 'Chit Tracker உங்கள் எல்லா சீட்களையும் எளிதாகக் கண்காணிக்க உதவுகிறது.',
            upcomingInstallments: 'வரவிருக்கும் தவணைகள்',
            incomplete: 'நடப்பது',
            completed: 'முடிந்தது',
            auctionAmount: 'ஏல தொகை',
            winnerTook: 'வெற்றியாளர் பெற்றது',
            winner: 'வெற்றியாளர்',
            remMembersPaid: 'மீதம் உள்ள உறுப்பினர்கள் செலுத்தியது',
            prevWinnersPaid: 'முந்தைய வெற்றியாளர்கள் செலுத்தியது',
            fee: 'கட்டணம்',
            expense: 'செலவு',
            totalExpenses: 'மொத்த செலவு',
            commission: 'தள்ளுபடி',
            nextAuction: 'அடுத்த ஏலம்',
            completedAuctions: 'முடிவடைந்த ஏலங்கள்',
            addChitDetailsMessage: 'சீட்டு விவரங்களைச் சேர்க்கவும்.',
            chitDetailMembers: 'உறுப்பினர்கள்',
            installmentsRemaining_one: 'தவணை மீதமுள்ளது',
            installmentsRemaining_other: 'தவணைகள் மீதமுள்ளது',
            intervalMonth_one: '{{count}} மாதத்திற்கு',
            intervalMonth_other: '{{count}} மாதங்களுக்கு',
            interval: '{{frequency}} ஒரு முறை',
            addAuctionTitle: '\'{{chitName}}\' சீட்டுக்கான ஏலத்தைச் சேர்க்கவும்',
            editAuctionTitle: '\'{{chitName}}\' சீட்டுக்கான ஏலத்தைச் திருத்தவும்',
            prevAuctionAmount: 'முந்தைய ஏல தொகை',
            prevWinnerTook: 'முந்தைய வெற்றியாளர் பெற்றது',
            calculatePayableMessage: 'செலுத்த வேண்டியதை கணக்கிட மேலே உள்ள விவரங்களை உள்ளிடவும்.',
            calculatePayableErrMsg: 'செலுத்த வேண்டிய தொகையைக் கணக்கிடுங்கள்',
            winnerTakes: 'வெற்றி பெற்றவற்கு \'{{amount}}\' செலுத்தவேண்டும்.',
            previousWinnersPay_one: 'முன் வெற்றி பெற்ற நபர் \'{{amount}}\' செலுத்த வேண்டும்.',
            previousWinnersPay_other: 'முன் வெற்றி பெற்ற {{count}} நபர்கள் ஒவ்வொருவரும் தலா \'{{amount}}\' செலுத்த வேண்டும்.',
            remMembersPay_one: 'மீதம் உள்ள நபர் \'{{amount}}\' செலுத்த வேண்டும்.',
            remMembersPay_other: 'மீதம் உள்ள {{count}} நபர்கள் ஒவ்வொருவரும் தலா \'{{amount}}\' செலுத்த வேண்டும்.',
            chitsIncompleteMessage: 'சீட்டுகள் இன்னும் முடிவடையவில்லை.',
            loginErrorInvalidCredentials: 'மின்னஞ்சல் மற்றும் கடவுச்சொல்லை சரிபார்க்கவும்.',
            loginErrorEmailNotConfirmed: 'உங்களுக்கு அனுப்பிய மின்னஞ்சலில் உள்ள "Confirm your mail" என்பதைக் கிளிக் செய்யவும்.',
            loginErrorGeneric: 'உள்நுழைவின் போது ஏதோ தவறு ஏற்பட்டுள்ளது.',
            signupErrorPassword: 'கடவுச்சொல் குறைந்தது 6 எழுத்துகளாக இருக்க வேண்டும்.',
            signupErrorGeneric: 'பதிவு செய்யும் போது ஏதோ தவறு ஏற்பட்டுள்ளது.',
            signupSuccess: 'பதிவுசெய்தல் வெற்றியடைந்தது! உங்களுக்கு அனுப்பிய மின்னஞ்சலில் உள்ள "Confirm your mail" என்பதைக் கிளிக் செய்யவும்.',
            dataUpdateErrorGeneric: "ஏதோ தவறு நடந்துவிட்டது! தயவுசெய்து மீண்டும் முயற்சி செய்க.",
            dataUpdateErrorAuctionForm: "புதிய ஏலம் சேர்க்கப்பட்டது ஆனால் சீட்டு புதுப்பிக்கப்படவில்லை.",
            pastAuctionsFetchError: "கடந்த கால ஏலங்களைக் கண்டறியும் போது ஏதோ தவறு ஏற்பட்டது! பக்கத்தைப் புதுப்பிக்கவும்.",
            summary: "சுருக்கம்",
            totalAmountPaid: "செலுத்தப்பட்ட மொத்த தொகை",
            wonAuctionBadgeMessage: "ஏலத்தில் வென்றேன்",
            wonAmount: "வென்ற தொகை"
          }
        }
      }
    }
  });

export default i18n;
